"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateArea = exports.deleteArea = exports.getArea = exports.addArea = exports.getAreasByRegionId = exports.getAreas = void 0;
const _ = require("lodash");
const getAreas = async (supabase) => {
    const { data: areas, error } = await supabase.from("areas").select(`*, 
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name),
      region:region_id ( id, name, slug, country:country_id ( id, name, slug ) )`);
    if (!error)
        return areas.map((area) => ({
            id: area.id,
            name: area.name,
            type: area.type,
            created_at: area.created_at,
            created_by: area.created_by,
            created_by_user: area.created_by_user,
            modified_by_user: area.modified_by_user,
            modified_at: area.modified_at,
            modified_by: area.modified_by,
            region: {
                id: area?.region?.id,
                name: area?.region?.name,
                slug: area?.region?.slug,
            },
            country: {
                id: area?.region?.country?.id,
                name: area?.region?.country?.name,
                slug: area?.region?.country?.slug,
            },
        }));
    return error;
};
exports.getAreas = getAreas;
const getAreasByRegionId = async (supabase, regionId) => {
    const { data: areas, error } = await supabase
        .from("areas")
        .select(`*, 
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name),
      region:region_id!inner ( id, name, slug, country:country_id ( id, name, slug ) )`)
        .eq("region_id", regionId);
    if (!error)
        return areas.map((area) => ({
            id: area.id,
            name: area.name,
            type: area.type,
            created_at: area.created_at,
            created_by: area.created_by,
            created_by_user: area.created_by_user,
            modified_by_user: area.modified_by_user,
            modified_at: area.modified_at,
            modified_by: area.modified_by,
            region: {
                id: area?.region?.id,
                name: area?.region?.name,
                slug: area?.region?.slug,
            },
            country: {
                id: area?.region?.country?.id,
                name: area?.region?.country?.name,
                slug: area?.region?.country?.slug,
            },
        }));
    return error;
};
exports.getAreasByRegionId = getAreasByRegionId;
const addArea = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        obj.modified_by = user?.id;
        obj.created_by = user?.id;
    }
    const { data, error } = await supabase.from("areas").insert([obj]).select();
    if (!error)
        return data;
    return error;
};
exports.addArea = addArea;
const getArea = async (supabase, id) => {
    const { data: area, error } = await supabase
        .from("areas")
        .select(`*,region:region_id ( id, name, slug, country:country_id ( id, name, slug ) ),
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return area;
    return error;
};
exports.getArea = getArea;
const deleteArea = async (supabase, id) => {
    const { data, error } = await supabase
        .from("areas")
        .delete()
        .match({ id: id });
    if (!error)
        return data;
    return error;
};
exports.deleteArea = deleteArea;
const updateArea = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
    }
    delete updateObj.region;
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("areas")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateArea = updateArea;
